const red400Color = '#CB4D4D';

export default red400Color;
